import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useCustomer } from "@/lib/customerAuth";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refresh } = useCustomer();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = loc.hash.match(/session_id=([^&]+)/);
    const sid = m?.[1];
    if (!sid) { nav("/"); return; }
    (async () => {
      try {
        await api.post("/auth/customer/session", null, { headers: { "X-Session-ID": sid } });
        await refresh();
        window.history.replaceState(null, "", "/my-bookings");
        toast.success("Signed in with Google");
        nav("/my-bookings", { replace: true });
      } catch { toast.error("Sign-in failed"); nav("/book-service", { replace: true }); }
    })();
  }, [loc.hash, nav, refresh]);

  return <div className="min-h-[60vh] flex items-center justify-center text-sm uppercase tracking-widest text-[#666]">Signing you in…</div>;
}
